
(() => {
  if (window.__veronaVerticalGalleryLoaded) return;
  window.__veronaVerticalGalleryLoaded = true;

  const selector =
    '.product__media-wrapper media-gallery[data-desktop-layout="thumbnail_slider"]';
  const desktop = window.matchMedia('(min-width: 990px)');
  const instances = new Map();

  function mount(gallery) {
    if (instances.has(gallery)) return;

    const rail = gallery.querySelector(
      '.thumbnail-slider .thumbnail-list'
    );

    if (!rail) return;

    let frame = 0;

    function keepActiveVisible() {
      if (!desktop.matches || !rail.isConnected) return;

      const active = rail.querySelector('.thumbnail[aria-current]');
      if (!active) return;

      const container = rail.getBoundingClientRect();
      const target = active.getBoundingClientRect();
      let delta = 0;

      if (target.top < container.top + 4) {
        delta = target.top - container.top - 4;
      } else if (target.bottom > container.bottom - 4) {
        delta = target.bottom - container.bottom + 4;
      }

      if (delta) rail.scrollTop += delta;
    }

    function refresh() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(keepActiveVisible);
    }

    const observer = new MutationObserver(refresh);

    observer.observe(rail, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current']
    });

    instances.set(gallery, {
      refresh,
      destroy() {
        observer.disconnect();
        cancelAnimationFrame(frame);
      }
    });

    refresh();
  }

  function init(root = document) {
    root.querySelectorAll(selector).forEach(mount);
  }

  function start() {
    init();

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((instance, gallery) => {
        if (event.target.contains(gallery)) {
          instance.destroy();
          instances.delete(gallery);
        }
      });
    });

    desktop.addEventListener('change', () => {
      instances.forEach((instance) => instance.refresh());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();